<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'league',
  data: () => ({
    tabsArr: [
      {
        title: 'Fixtures',
        route: '/league'
      },
      {
        title: 'Table',
        route: '/app/league/table'
      }
    ]
  }),
  activated() {
    this.$store.commit('SET_PAGE_TITLE', 'premier league')
    this.$store.commit('SET_HEADER_TABS', this.tabsArr)
  },
  deactivated() {
    this.$store.commit('SET_HEADER_TABS', null)
  }
}
</script>
